import { handle } from 'redux-pack';
import {
  FETCH_SENSOR,
  FETCH_SENSOR_BY_ID,
  FETCH_SENSOR_BY_ID_GRAFICA,
  FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID,
  FETCH_TIPO_SENSOR,
  LIMPIAR_ESTADO_SENSOR,
  CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
  LOGOUT
} from '../actions/types';

const initialState = {
  sensors: [],
  sensor: {},
  sensorTrama: null,
  tipoSensors: [],
  isLoading: false,
  error: null,
};

const sensorReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_SENSOR:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: true }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          sensors: payload.data,
        }),
      });
    case FETCH_SENSOR_BY_ID:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: true }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          sensor: payload.data,
        }),
      });
    case FETCH_SENSOR_BY_ID_GRAFICA:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: false }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          sensor: payload.data,
        }),
      });
    case FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: true }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          sensorTrama: payload.data,
        }),
      });
    case CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS:
      // Actualizar sensor en la lista cuando se cambia su estado
      if (action.payload.tipo === 'sensor') {
        const dispositivoActualizado = action.payload.dispositivo;
        const sensorId = dispositivoActualizado._id || dispositivoActualizado.id;

        return {
          ...state,
          // Solo actualizar la lista de sensores si existe y es un array
          sensors: Array.isArray(state.sensors) ? state.sensors.map(sensor =>
            sensor._id === sensorId
              ? { ...sensor, estatusDispositivo: dispositivoActualizado.estatusDispositivo }
              : sensor
          ) : state.sensors,
          // También actualizar el sensor individual si coincide con el ID
          sensor: state.sensor && (state.sensor._id === sensorId || state.sensor.id === sensorId)
            ? { ...state.sensor, estatusDispositivo: dispositivoActualizado.estatusDispositivo }
            : state.sensor
        };
      }
      return state;
    case FETCH_TIPO_SENSOR:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: true }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          tipoSensors: payload.data,
        }),
      });
    case LIMPIAR_ESTADO_SENSOR:
      return {
        ...state,
        sensor: {},
        sensorTrama: null,
        error: null,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default sensorReducer;